"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2411],{

/***/ 89929:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32293);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41485);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);




var CustomModal = function(param) {
    var modalName = param.modalName, className = param.className, modalSize = param.modalSize, closeModal = param.closeModal, show = param.show, children = param.children, Title = param.Title;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(show || false), showModal = ref[0], setShowModal = ref[1];
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var hasHash = router.asPath.includes("#");
    // true only while this modal has its own #modalName entry in the browser history
    var pushedHistoryRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    var openHandler = function() {
        if (!hasHash) {
            router.push({
                hash: modalName + ""
            }, undefined, {
                scroll: false
            });
            pushedHistoryRef.current = true;
        }
        setShowModal(true);
    };
    var closeHandler = function() {
        closeModal();
        setShowModal(false);
        // go back only to undo this modal's own #hash entry. Modals opened by their parent (show={true}) add no
        // history entry, and going back there left the page or reopened the previous modal/article.
        if (pushedHistoryRef.current) {
            pushedHistoryRef.current = false;
            router.back();
        }
    };
    // const clickOutSideHandler = () => {
    //   closeModal();
    //   setShowModal( false );
    // }
    // useEffect( () => {
    //   if ( show ) openHandler();
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [show])
    // useEffect( () => {
    //   if ( !hasHash && showModal ) clickOutSideHandler();
    //   // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [hasHash]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        id: modalName,
        className: className,
        size: modalSize,
        show: show,
        onHide: closeHandler,
        animation: true,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Header */ .Z.Header, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        onClick: closeHandler
                    }),
                    Title
                ]
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(CustomModal));


/***/ }),

/***/ 63924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Motto; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _templates_index_BookingSearchBar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83074);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9473);
/* harmony import */ var _helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28695);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55791);







var MOTTO_FONT_SIZE_CSS = "\n  .line-height-1-2 { line-height: 1.2 !important; }\n  .fs-30 { font-size: 30px !important; }\n  @media (min-width: 768px) {\n    .fs-md-35 { font-size: 35px !important; }\n  }\n  @media (min-width: 992px) {\n    .fs-lg-60 { font-size: 60px !important; }\n  }\n";
function Motto(props) {
    var isMobile = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["isMobile"];
    });
    var isTablet = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["isTablet"];
    });
    var isDesktop = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["isDesktop"];
    });
    var isHomePage = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["appSettings"]["isHomePage"];
    });
    var app = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return state["builderSettingsData"]["settings"];
    });
    var isFlexible = props.isFlexible;
    var logo = app.logoDecoration;
    var jumbotronTextAlign = null;
    var jumbotronTextColor = null;
    //---------------- TEXT ALIGNMENT ----------------
    if (props.jumbotronTextAlign == 0) jumbotronTextAlign = "align-items-start text-left justify-content-start";
    else if (props.jumbotronTextAlign == 1) jumbotronTextAlign = "align-items-center text-center justify-content-center";
    else if (props.jumbotronTextAlign == 2) jumbotronTextAlign = "align-items-end text-right justify-content-center";
    else jumbotronTextAlign = "align-items-start";
    //---------------- TEXT COLOR ----------------
    if (props.jumbotronTextColor) jumbotronTextColor = "text-white";
    else jumbotronTextColor = "text-black";
    //---------------- TEXT BOLD ----------------
    if (props.sliderTitleBold) jumbotronTextColor += " bold";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), headerHeight = ref[0], setHeaderHeight = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!props.sliderSearchBarBelowHeader) return;
        var header = document.querySelector(".Header");
        if (!header) return;
        var measure = function() {
            return setHeaderHeight(header.offsetHeight);
        };
        measure();
        var observer = new MutationObserver(measure);
        observer.observe(header, {
            attributes: true,
            attributeFilter: [
                "class"
            ]
        });
        window.addEventListener("resize", measure);
        return function() {
            observer.disconnect();
            window.removeEventListener("resize", measure);
        };
    }, [
        props.sliderSearchBarBelowHeader
    ]);
    var homepageMottoOverride = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_5__/* .fetchBuilderSettingByKey */ .iS)(state["builderSettingsData"], "builder_homepage_motto_overide");
    });
    var homeTitleMotto = function() {
        return _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_6__/* ["default"].isValidString */ .Z.isValidString(homepageMottoOverride) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: homepageMottoOverride
            }
        }) : props.homeTitle;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "motto inner full-height position-absolute top-0 h-100 w-100",
        style: {
            pointerEvents: "none"
        },
        children: [
            !!props.sliderSearchBarBelowHeader && (isDesktop || isTablet) && headerHeight !== null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    position: "absolute",
                    top: headerHeight,
                    left: 0,
                    right: 0,
                    zIndex: 100,
                    textAlign: "left"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_templates_index_BookingSearchBar__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    isManager: props.isManager,
                    sliderSearchBar: true,
                    designMode: props.designMode,
                    searchbarThemeColor: props.hasOwnProperty("searchbarThemeColor") ? props.searchbarThemeColor : null,
                    rgbaDesignColor: props.rgbaDesignColor,
                    searchbarRadius: props.searchbarRadius,
                    searchbarShadow: props.searchbarShadow,
                    bookingSearchbarWithBedrooms: props.bookingSearchbarWithBedrooms,
                    isHomePage: true,
                    isFlexible: isFlexible,
                    bookingTypeValue: props.bookingTypeValue,
                    webHotelierRoomCodes: props.webHotelierRoomCodes,
                    webHotelierBookUrl: props.webHotelierBookUrl,
                    propertyBookingTypeValue: props.propertyBookingTypeValue,
                    managerInfo: props.managerInfo
                })
            }) : null,
            !!props.sliderSearchBarTop && (isDesktop || isTablet) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    position: "absolute",
                    bottom: 24,
                    left: 0,
                    right: 0,
                    zIndex: 100,
                    textAlign: "left"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_templates_index_BookingSearchBar__WEBPACK_IMPORTED_MODULE_3__["default"], {
                    isManager: props.isManager,
                    sliderSearchBar: true,
                    designMode: props.designMode,
                    searchbarThemeColor: props.hasOwnProperty("searchbarThemeColor") ? props.searchbarThemeColor : null,
                    rgbaDesignColor: props.rgbaDesignColor,
                    searchbarRadius: props.searchbarRadius,
                    searchbarShadow: props.searchbarShadow,
                    bookingSearchbarWithBedrooms: props.bookingSearchbarWithBedrooms,
                    isHomePage: true,
                    isFlexible: isFlexible,
                    bookingTypeValue: props.bookingTypeValue,
                    webHotelierRoomCodes: props.webHotelierRoomCodes,
                    webHotelierBookUrl: props.webHotelierBookUrl,
                    propertyBookingTypeValue: props.propertyBookingTypeValue,
                    managerInfo: props.managerInfo
                })
            }) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container-xs-height full-height",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "col-xs-height col-middle text-left",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row justify-content-center w-100 no-margin",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "container",
                                    children: props.hasOwnProperty("hideMotto") ? "" : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "row no-gutter",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "col-sm-12 col-sm-offset-0 d-flex flex-column justify-content-center " + jumbotronTextAlign + " " + jumbotronTextColor + " z-index-3",
                                            children: props.motto !== undefined || isDesktop && props.logoDecoration != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                children: [
                                                    isDesktop && props.logoDecoration != null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "d-flex col-8 h-auto logo-decoration-div hidden-xs " + jumbotronTextAlign,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                            loading: "eager",
                                                            width: props.logoDecorationOriginWidth,
                                                            height: props.logoDecorationOriginHeight,
                                                            objectFit: "contain",
                                                            className: "image logo-decoration",
                                                            alt: "logo_decoration",
                                                            src: props.logoDecoration,
                                                            placeholder: "blur",
                                                            blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                                        })
                                                    }) : "",
                                                    props.motto !== undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                                                                children: MOTTO_FONT_SIZE_CSS
                                                            }),
                                                            homeTitleMotto() != null || props.homeSubtitle != null ? homeTitleMotto() != null && props.homeSubtitle == null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                                    className: "font-montserrat m-b-0 p-b-20 fs-30 fs-md-35 fs-lg-60 " + jumbotronTextColor,
                                                                    style: {
                                                                        textShadow: props.sliderTitleShadow ? "1px 1px 5px #333" : "none"
                                                                    },
                                                                    children: homeTitleMotto()
                                                                })
                                                            }) : props.homeSubtitle != null && homeTitleMotto() == null ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "h3 font-montserrat fs-14 text-uppercase m-t-0 m-b-40 " + jumbotronTextColor,
                                                                    style: {
                                                                        textShadow: props.sliderTitleShadow ? "1px 1px 5px #333" : "none"
                                                                    },
                                                                    children: props.homeSubtitle
                                                                })
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                                        className: "font-montserrat m-b-0 p-b-20 fs-30 fs-md-35 fs-lg-60 order-2 line-height-1-2 m-t-0 " + jumbotronTextColor,
                                                                        style: {
                                                                            textShadow: props.sliderTitleShadow ? "1px 1px 5px #333" : "none"
                                                                        },
                                                                        children: homeTitleMotto()
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                        className: "h3 font-montserrat fs-14 text-uppercase m-t-0 order-1 " + jumbotronTextColor,
                                                                        style: {
                                                                            textShadow: props.sliderTitleShadow ? "1px 1px 5px #333" : "none"
                                                                        },
                                                                        children: props.homeSubtitle
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                                    className: "font-montserrat m-b-0 p-b-20 fs-30 fs-md-35 fs-lg-60 " + jumbotronTextColor,
                                                                    style: {
                                                                        textShadow: props.sliderTitleShadow ? "1px 1px 5px #333" : "none"
                                                                    },
                                                                    children: props.motto
                                                                })
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                                ]
                                            }) : ""
                                        })
                                    })
                                })
                            })
                        }),
                        props.sliderSearchBar == true && !props.sliderSearchBarBelowHeader && !props.sliderSearchBarTop && (isDesktop || isTablet) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_templates_index_BookingSearchBar__WEBPACK_IMPORTED_MODULE_3__["default"], {
                            isManager: props.isManager,
                            sliderSearchBar: true,
                            designMode: props.designMode,
                            searchbarThemeColor: props.hasOwnProperty("searchbarThemeColor") ? props.searchbarThemeColor : null,
                            rgbaDesignColor: props.rgbaDesignColor,
                            searchbarRadius: props.searchbarRadius,
                            searchbarShadow: props.searchbarShadow,
                            bookingSearchbarWithBedrooms: props.bookingSearchbarWithBedrooms,
                            isHomePage: true,
                            isFlexible: isFlexible,
                            bookingTypeValue: props.bookingTypeValue,
                            webHotelierRoomCodes: props.webHotelierRoomCodes,
                            webHotelierBookUrl: props.webHotelierBookUrl,
                            propertyBookingTypeValue: props.propertyBookingTypeValue,
                            managerInfo: props.managerInfo
                        }) : ""
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 93801:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51438);

var SwiperUtils = /*#__PURE__*/ function() {
    "use strict";
    function SwiperUtils(options) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(this, SwiperUtils);
        this.mode = "white";
        this.swiperPagination = document.querySelector(".swiper-pagination-horizontal");
        this.swiperPaginationBullets = document.querySelectorAll(".swiper-pagination-bullet");
        this.options = options;
    }
    var _proto = SwiperUtils.prototype;
    _proto.swiperOptions = function swiperOptions() {
        var _this = this;
        if (this.options.mode) {
            this.mode = this.options.mode;
        }
        var bg_class = "bg-" + this.mode;
        this.swiperPaginationBullets.forEach(function(element) {
            element.classList.add(bg_class);
        });
        window.addEventListener("resize", function() {
            _this.swiperPaginationBullets = document.querySelectorAll(".swiper-pagination-bullet");
            _this.swiperPaginationBullets.forEach(function(element) {
                if (!element.classList.contains(bg_class)) {
                    element.classList.add(bg_class);
                }
            });
        });
        if (this.options.pagination) {
            this.swiperPagination.classList.remove("visible-xs");
            this.swiperPagination.classList.remove("visible-sm");
        } else {
            this.swiperPagination.classList.remove("visible-xs");
            this.swiperPagination.classList.remove("visible-sm");
        }
    };
    return SwiperUtils;
}();
/* harmony default export */ __webpack_exports__["Z"] = (SwiperUtils);


/***/ }),

/***/ 82411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55791);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30719);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71911);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(67814);
/* harmony import */ var _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(73582);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _plugins_swiperUtils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(93801);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _property_partials_gallery_GalleryItem__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14708);
/* harmony import */ var _CustomModal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89929);
/* harmony import */ var _property_partials_modals_ModalPropertyImages__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(63644);
/* harmony import */ var _helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(28695);
/* harmony import */ var _jumbotron_Motto__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(63924);

















swiper__WEBPACK_IMPORTED_MODULE_3__/* ["default"].use */ .ZP.use([
    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Autoplay */ .pt,
    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Navigation */ .W_,
    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Pagination */ .tl,
    swiper__WEBPACK_IMPORTED_MODULE_3__/* .Lazy */ .oM
]);
var SwipperWrapper = function(param) {
    var images = param.images, _imagesToShow = param.imagesToShow, imagesToShow = _imagesToShow === void 0 ? null : _imagesToShow, _imageKey = param.imageKey, imageKey = _imageKey === void 0 ? "image" : _imageKey, _galleryHeight = param.galleryHeight, galleryHeight = _galleryHeight === void 0 ? "auto" : _galleryHeight, _paginationBulletsEnabled = param.paginationBulletsEnabled, paginationBulletsEnabled = _paginationBulletsEnabled === void 0 ? true : _paginationBulletsEnabled, _paginationBullets = param.paginationBullets, paginationBullets = _paginationBullets === void 0 ? true : _paginationBullets, _dynamicMainBullets = param.dynamicMainBullets, dynamicMainBullets = _dynamicMainBullets === void 0 ? 6 : _dynamicMainBullets, _imageSlider = param.imageSlider, imageSlider = _imageSlider === void 0 ? true : _imageSlider, htmlSlides = param.htmlSlides, _slidesPerView = param.slidesPerView, slidesPerView = _slidesPerView === void 0 ? 1 : _slidesPerView, _slidesPerViewLg = param.slidesPerViewLg, slidesPerViewLg = _slidesPerViewLg === void 0 ? 1 : _slidesPerViewLg, _slidesPerViewMd = param.slidesPerViewMd, slidesPerViewMd = _slidesPerViewMd === void 0 ? 1 : _slidesPerViewMd, _slidesPerViewSm = param.slidesPerViewSm, slidesPerViewSm = _slidesPerViewSm === void 0 ? 1 : _slidesPerViewSm, _slidesPerViewXs = param.slidesPerViewXs, slidesPerViewXs = _slidesPerViewXs === void 0 ? 1 : _slidesPerViewXs, _wrapperClassName = param.wrapperClassName, wrapperClassName = _wrapperClassName === void 0 ? "Properties__gallery m-t-20" : _wrapperClassName, _enableAutoplay = param.enableAutoplay, enableAutoplay = _enableAutoplay === void 0 ? false : _enableAutoplay, _designMode = param.designMode, designMode = _designMode === void 0 ? 1 : _designMode, _spaceBetween = param.spaceBetween, spaceBetween = _spaceBetween === void 0 ? 20 : _spaceBetween, _customNavigationArrows = param.customNavigationArrows, customNavigationArrows = _customNavigationArrows === void 0 ? true : _customNavigationArrows, _fadeBottom = param.fadeBottom, fadeBottom = _fadeBottom === void 0 ? false : _fadeBottom, _enableFancyBox = param.enableFancyBox, enableFancyBox = _enableFancyBox === void 0 ? true : _enableFancyBox, _enableAlbumRightModal = param.enableAlbumRightModal, enableAlbumRightModal = _enableAlbumRightModal === void 0 ? true : _enableAlbumRightModal, _centeredSlides = param.centeredSlides, centeredSlides = _centeredSlides === void 0 ? true : _centeredSlides, _enableLoop = param.enableLoop, enableLoop = _enableLoop === void 0 ? false : _enableLoop, _jumbotronOverlayOpacity = param.jumbotronOverlayOpacity, jumbotronOverlayOpacity = _jumbotronOverlayOpacity === void 0 ? 0 : _jumbotronOverlayOpacity, _motto = param.motto, motto = _motto === void 0 ? null : _motto, _isManager = param.isManager, isManager = _isManager === void 0 ? null : _isManager, _bookingSearchbarWithBedrooms = param.bookingSearchbarWithBedrooms, bookingSearchbarWithBedrooms = _bookingSearchbarWithBedrooms === void 0 ? null : _bookingSearchbarWithBedrooms, _calendar = param.calendar, calendar = _calendar === void 0 ? null : _calendar, _sliderSearchBar = param.sliderSearchBar, sliderSearchBar = _sliderSearchBar === void 0 ? null : _sliderSearchBar, _sliderSearchBarTop = param.sliderSearchBarTop, sliderSearchBarTop = _sliderSearchBarTop === void 0 ? null : _sliderSearchBarTop, _sliderSearchBarBelowHeader = param.sliderSearchBarBelowHeader, sliderSearchBarBelowHeader = _sliderSearchBarBelowHeader === void 0 ? null : _sliderSearchBarBelowHeader, _isFlexible = param.isFlexible, isFlexible = _isFlexible === void 0 ? false : _isFlexible, _rgbaDesignColor = param.rgbaDesignColor, rgbaDesignColor = _rgbaDesignColor === void 0 ? null : _rgbaDesignColor, _searchbarRadius = param.searchbarRadius, searchbarRadius = _searchbarRadius === void 0 ? null : _searchbarRadius, _searchbarShadow = param.searchbarShadow, searchbarShadow = _searchbarShadow === void 0 ? null : _searchbarShadow, _searchbarThemeColor = param.searchbarThemeColor, searchbarThemeColor = _searchbarThemeColor === void 0 ? null : _searchbarThemeColor, _firstSlideTitle = param.firstSlideTitle, firstSlideTitle = _firstSlideTitle === void 0 ? null : _firstSlideTitle, _firstSlideSubtitle = param.firstSlideSubtitle, firstSlideSubtitle = _firstSlideSubtitle === void 0 ? null : _firstSlideSubtitle, _logoDecoration = param.logoDecoration, logoDecoration = _logoDecoration === void 0 ? null : _logoDecoration, _logoDecorationOriginWidth = param.logoDecorationOriginWidth, logoDecorationOriginWidth = _logoDecorationOriginWidth === void 0 ? null : _logoDecorationOriginWidth, _logoDecorationOriginHeight = param.logoDecorationOriginHeight, logoDecorationOriginHeight = _logoDecorationOriginHeight === void 0 ? null : _logoDecorationOriginHeight, _jumbotronTextAlign = param.jumbotronTextAlign, jumbotronTextAlign = _jumbotronTextAlign === void 0 ? null : _jumbotronTextAlign, _jumbotronTextColor = param.jumbotronTextColor, jumbotronTextColor = _jumbotronTextColor === void 0 ? null : _jumbotronTextColor, _sliderTitleShadow = param.sliderTitleShadow, sliderTitleShadow = _sliderTitleShadow === void 0 ? null : _sliderTitleShadow, _sliderTitleBold = param.sliderTitleBold, sliderTitleBold = _sliderTitleBold === void 0 ? null : _sliderTitleBold, _pageTitle = param.pageTitle, pageTitle = _pageTitle === void 0 ? null : _pageTitle, _bookingTypeValue = param.bookingTypeValue, bookingTypeValue = _bookingTypeValue === void 0 ? null : _bookingTypeValue, _webHotelierRoomCodes = param.webHotelierRoomCodes, webHotelierRoomCodes = _webHotelierRoomCodes === void 0 ? null : _webHotelierRoomCodes, _webHotelierBookUrl = param.webHotelierBookUrl, webHotelierBookUrl = _webHotelierBookUrl === void 0 ? null : _webHotelierBookUrl, _propertyBookingTypeValue = param.propertyBookingTypeValue, propertyBookingTypeValue = _propertyBookingTypeValue === void 0 ? null : _propertyBookingTypeValue, _managerInfo = param.managerInfo, managerInfo = _managerInfo === void 0 ? null : _managerInfo;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(Math.random().toString(36).slice(3)), swiperId = ref[0], setSwiperId = ref[1];
    var size = (0,_helpers_MethodHelper__WEBPACK_IMPORTED_MODULE_12__/* .useWindowSize */ .iP)();
    var visibleSlides = function() {
        if (size["width"] > 1200) return slidesPerView;
        if (size["width"] > 991) return slidesPerViewLg;
        if (size["width"] > 768) return slidesPerViewMd;
        if (size["width"] > 576) return slidesPerViewSm;
        if (size["width"] <= 576) return slidesPerViewXs;
        return slidesPerView;
    };
    var getImagesForSwiper = function() {
        var images_for_swiper = [];
        if (imagesToShow != null) {
            images && images.map(function(item, index) {
                if (index < imagesToShow) {
                    images_for_swiper.push(item);
                }
            });
        } else {
            images && images.map(function(item, index) {
                images_for_swiper.push(item);
            });
        }
        return images_for_swiper;
    };
    var imagesForSwiper = getImagesForSwiper();
    var myLoader = function(param) {
        var src = param.src;
        return "".concat(src, "?q=55");
    };
    var autoplay = {
        delay: 2500,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
    };
    var fancyBoxName = "gallery_" + (Math.random() + 1).toString(36).substring(10);
    var navigationHandler = function() {
        if (imageSlider && images.length < 2) {
            return false;
        }
        if (customNavigationArrows) {
            return _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isValidArray */ .Z.isValidArray(images) && images.length > 1 || htmlSlides != undefined && htmlSlides.length > 0 ? {
                enabled: true,
                nextEl: ".swiper-custom-next-" + swiperId,
                prevEl: ".swiper-custom-prev-" + swiperId
            } : false;
        } else {
            return true;
        }
    };
    var navigation = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(navigationHandler());
    var swiper_options = {
        mode: "white"
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(function() {
        if (router.route.includes("/blog")) {
            if (window !== undefined) {
                swiper_options.mode = designMode == 1 ? "white" : "dark";
            }
            new _plugins_swiperUtils__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z(swiper_options).swiperOptions();
        }
    });
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false), show = ref1[0], setShow = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)("close"), modalState = ref2[0], setModalState = ref2[1];
    var handleShow = function(state) {
        setShow(true);
        setModalState("property_featured_photos_modal_slider");
        return true;
    };
    var handleHide = function() {
        setShow(false);
        setModalState("close");
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: wrapperClassName + " properties",
                style: {
                    height: galleryHeight,
                    position: "relative"
                },
                children: [
                    motto != null && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_jumbotron_Motto__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                        motto: motto,
                        isManager: isManager,
                        bookingSearchbarWithBedrooms: bookingSearchbarWithBedrooms,
                        calendar: calendar,
                        sliderSearchBar: sliderSearchBar,
                        sliderSearchBarTop: sliderSearchBarTop,
                        sliderSearchBarBelowHeader: sliderSearchBarBelowHeader,
                        isFlexible: isFlexible,
                        rgbaDesignColor: rgbaDesignColor,
                        searchbarRadius: searchbarRadius,
                        searchbarShadow: searchbarShadow,
                        searchbarThemeColor: searchbarThemeColor,
                        logoDecoration: logoDecoration,
                        logoDecorationOriginWidth: logoDecorationOriginWidth,
                        logoDecorationOriginHeight: logoDecorationOriginHeight,
                        jumbotronTextAlign: jumbotronTextAlign,
                        jumbotronTextColor: jumbotronTextColor,
                        sliderTitleShadow: sliderTitleShadow,
                        sliderTitleBold: sliderTitleBold,
                        homeTitle: firstSlideTitle,
                        homeSubtitle: firstSlideSubtitle,
                        bookingTypeValue: bookingTypeValue,
                        webHotelierRoomCodes: webHotelierRoomCodes,
                        webHotelierBookUrl: webHotelierBookUrl,
                        propertyBookingTypeValue: propertyBookingTypeValue,
                        managerInfo: managerInfo
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .Swiper */ .tq, {
                        id: swiperId,
                        spaceBetween: spaceBetween,
                        speed: 1000,
                        navigation: navigationHandler(),
                        noSwiping: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isValidBoolean */ .Z.isValidBoolean(navigation),
                        pagination: {
                            enabled: paginationBulletsEnabled,
                            dynamicBullets: paginationBullets,
                            dynamicMainBullets: dynamicMainBullets,
                            clickable: true
                        },
                        loop: enableLoop,
                        style: {
                            borderRadius: "0px"
                        },
                        slidesPerView: visibleSlides(),
                        autoplay: enableAutoplay ? autoplay : false,
                        centeredSlides: centeredSlides,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: customNavigationArrows && (images != undefined && images.length > 1 || htmlSlides != undefined && htmlSlides.length > 1) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "swiper-button-prev swiper-custom-prev-" + swiperId + " swiper-custom-prev " + "".concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isValidBoolean */ .Z.isValidBoolean(navigation) ? "hidden" : ""),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_6__/* .FontAwesomeIcon */ .G, {
                                                icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_15__/* .faAngleLeft */ .EyR,
                                                className: "text-master fs-16"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "swiper-button-next swiper-custom-next-" + swiperId + " swiper-custom-next " + "".concat(_helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isValidBoolean */ .Z.isValidBoolean(navigation) ? "hidden" : ""),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_6__/* .FontAwesomeIcon */ .G, {
                                                icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_15__/* .faAngleRight */ .yOZ,
                                                className: "text-master fs-16"
                                            })
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                            }),
                            imageSlider ? imagesForSwiper.map(function(slide, key) {
                                return _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isValidString */ .Z.isValidString(slide[imageKey]) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_2__/* .SwiperSlide */ .o5, {
                                    onClick: handleShow,
                                    children: [
                                        !enableFancyBox ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                                                    className: "w-100 " + galleryHeight,
                                                    style: {
                                                        height: "auto"
                                                    },
                                                    loader: myLoader,
                                                    priority: key == 0,
                                                    layout: "fill",
                                                    sizes: "55vw",
                                                    quality: "55",
                                                    src: slide[imageKey],
                                                    // alt={'Property Slide-' + props.property_id + '-' + key}
                                                    objectFit: "cover",
                                                    placeholder: "blur",
                                                    alt: _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isValidString */ .Z.isValidString(pageTitle) ? pageTitle : _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].removeEmojis */ .Z.removeEmojis(slide === null || slide === void 0 ? void 0 : slide["caption"]) ? _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].removeEmojis */ .Z.removeEmojis(slide["caption"]) : _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_1__/* ["default"].removeEmojis */ .Z.removeEmojis(slide === null || slide === void 0 ? void 0 : slide["service_image_caption"]) || "carousel image" + "-" + key,
                                                    blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: jumbotronOverlayOpacity > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "bg-overlay z-index-1",
                                                        style: {
                                                            backgroundColor: "rgb(0, 0, 0)",
                                                            opacity: jumbotronOverlayOpacity
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: slide.caption != null && slide.caption.length > 0 && motto != null && key != 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "bottom-right p-r-70 p-b-50 sm-p-r-20 sm-p-b-20 hidden-xs",
                                                        style: {
                                                            zIndex: 999
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                            className: "text-white text-right pull-right m-r-10",
                                                            children: slide.caption
                                                        })
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_property_partials_gallery_GalleryItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            fancybox: fancyBoxName,
                                            className: " w-100 h-100 ",
                                            imageSize: "55vw",
                                            imageQuality: 55,
                                            image: slide[imageKey],
                                            imageThumb: slide[imageKey],
                                            caption: slide["caption"],
                                            enableHoverZoom: false,
                                            galleryClassName: " col-12 ",
                                            arrClassName: " ar-2-1 h-100 "
                                        }, slide.image_id != undefined ? slide.image_id.toString() : key),
                                        fadeBottom ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "bg-overlay z-index-1 position-absolute start-0",
                                                    style: {
                                                        background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.0) , rgba(0, 0, 0, 0.3))",
                                                        height: "35%",
                                                        top: "unset",
                                                        bottom: "15%"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "bg-overlay z-index-1 position-absolute start-0",
                                                    style: {
                                                        background: "linear-gradient(to bottom, rgba(0, 0, 0, 0.3) , rgba(0, 0, 0, 0.8))",
                                                        height: "15%",
                                                        top: "unset",
                                                        bottom: 0
                                                    }
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                    ]
                                }, key);
                            }) : htmlSlides.map(function(slide) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: slide
                                });
                            })
                        ]
                    }, swiperId)
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: enableAlbumRightModal && images && images.length > 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomModal__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        modalName: "property_featured_photos_modal_slider",
                        className: "slide_right",
                        modalSize: "lg",
                        closeModal: function() {
                            handleHide();
                        },
                        show: modalState === "property_featured_photos_modal_slider",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_property_partials_modals_ModalPropertyImages__WEBPACK_IMPORTED_MODULE_11__["default"], {
                            all_images: images,
                            handleHide: handleHide
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SwipperWrapper);


/***/ }),

/***/ 14708:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GalleryItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_NoSsr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79104);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55791);




function GalleryItem(param) {
    var _index = param.index, index = _index === void 0 ? null : _index, galleryClassName = param.galleryClassName, fancybox = param.fancybox, className = param.className, arrClassName = param.arrClassName, image = param.image, imageThumb = param.imageThumb, image_id = param.image_id, _imageSize = param.imageSize, imageSize = _imageSize === void 0 ? "35vw" : _imageSize, _enableHoverZoom = param.enableHoverZoom, enableHoverZoom = _enableHoverZoom === void 0 ? true : _enableHoverZoom, _imageQuality = param.imageQuality, imageQuality = _imageQuality === void 0 ? 35 : _imageQuality, _wrapImage = param.wrapImage, wrapImage = _wrapImage === void 0 ? true : _wrapImage, _caption = param.caption, caption = _caption === void 0 ? undefined : _caption;
    var galleryClassNameLocal = "";
    var arrClassNameLocal = "";
    if (index != null) {
        switch(index){
            case 0:
                galleryClassNameLocal = "col-sm-6 col-12  ";
                arrClassNameLocal = "ar-2-1 ";
                break;
            case 1:
            case 2:
            case 3:
            case 4:
                galleryClassNameLocal = "col-sm-3 col-6 ";
                arrClassNameLocal = "ar-1-1";
                break;
            case 5:
                galleryClassNameLocal = "col-sm-6 col-12 ";
                arrClassNameLocal = "ar-2-1 ";
                break;
        }
    }
    if (galleryClassName != undefined) {
        galleryClassNameLocal += galleryClassName;
    }
    if (arrClassName != undefined) {
        arrClassNameLocal += arrClassName;
    }
    if (className != undefined) {
        galleryClassNameLocal += className + " ";
    }
    galleryClassNameLocal += " no-padding";
    if (enableHoverZoom) {
        galleryClassNameLocal += " hover-zoom";
    }
    var myLoader = function(param) {
        var src = param.src;
        return "".concat(src, "?q=55");
    };
    return wrapImage ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            "data-fancybox": fancybox,
            "data-src": image,
            "data-thumb": imageThumb,
            "data-caption": _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_2__/* ["default"].isValidString */ .Z.isValidString(caption) ? caption : undefined,
            className: galleryClassNameLocal,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: arrClassNameLocal,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    "data-pages-bg-image": "",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_NoSsr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            // loading={ key == 0 ? 'eager' : 'lazy'}
                            loader: myLoader,
                            layout: "fill",
                            sizes: imageSize,
                            quality: imageQuality,
                            src: imageThumb,
                            alt: caption ? _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_2__/* ["default"].removeEmojis */ .Z.removeEmojis(caption) : "Slide-" + (index != undefined ? index : image_id),
                            placeholder: "blur",
                            blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
                            objectFit: "cover"
                        })
                    })
                })
            })
        })
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            "data-fancybox": fancybox,
            "data-src": image,
            "data-thumb": imageThumb,
            "data-caption": _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_2__/* ["default"].isValidString */ .Z.isValidString(caption) ? caption : undefined,
            className: galleryClassName,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: arrClassName,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    "data-pages-bg-image": "",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_NoSsr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            // loading={ key == 0 ? 'eager' : 'lazy'}
                            loader: myLoader,
                            layout: "fill",
                            sizes: imageSize,
                            quality: imageQuality,
                            src: imageThumb,
                            alt: caption ? _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_2__/* ["default"].removeEmojis */ .Z.removeEmojis(caption) : "Slide-" + (index != undefined ? index : image_id),
                            placeholder: "blur",
                            blurDataURL: "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",
                            objectFit: "cover"
                        })
                    })
                })
            })
        })
    });
}


/***/ }),

/***/ 63644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _gallery_GalleryItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14708);



var ModalPropertyImages = function(props) {
    var skip = 0;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "modal-body",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "container",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "row w-100 no-margin",
                children: props.all_images.map(function(image) {
                    if (skip == 0 || skip == 3) {
                        skip = skip == 3 ? 0 : skip + 1;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_gallery_GalleryItem__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            fancybox: "album",
                            galleryClassName: "col-12 col-sm-6 padding-5 ",
                            arrClassName: "ar-2-1",
                            image: image.image,
                            imageThumb: image.image_thumb != undefined ? image.image_thumb : image.image
                        }, image.image_id != null ? image.image_id.toString() : image.image);
                    }
                    skip += 1;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_gallery_GalleryItem__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        fancybox: "album",
                        galleryClassName: "col-6 col-sm-3 padding-5 ",
                        arrClassName: "ar-1-1",
                        image: image.image,
                        caption: image.caption,
                        imageThumb: image.image_thumb != undefined ? image.image_thumb : image.image
                    }, image.image_id != null ? image.image_id.toString() : image.image);
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ModalPropertyImages);


/***/ })

}]);